import { projects } from "./local-storage/projects";
import { routes } from "./local-storage/routes";
import { coordinates } from "./local-storage/coordinates";

export const LocalStorageProvider = {
  projects,
  routes,
  coordinates
};
